export default {
      id: "icon-certified-ribbon-usage",
      viewBox: "0 0 105.71 105.71",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-certified-ribbon",
      toString: function () {
        return this.url;
      }
    }